import React from "react";

export const PurchasesIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      transform="translate(2 3)"
      d="M7 5C7 6.65686 8.34315 8 10 8C11.6569 8 13 6.65686 13 5M1 13.8002V4.2002C1 3.08009 1 2.51962 1.21799 2.0918C1.40974 1.71547 1.71547 1.40974 2.0918 1.21799C2.51962 1 3.08009 1 4.2002 1H15.8002C16.9203 1 17.4796 1 17.9074 1.21799C18.2837 1.40974 18.5905 1.71547 18.7822 2.0918C19 2.5192 19 3.079 19 4.19691V13.8036C19 14.9215 19 15.4805 18.7822 15.9079C18.5905 16.2842 18.2837 16.5905 17.9074 16.7822C17.48 17 16.921 17 15.8031 17H4.19691C3.079 17 2.5192 17 2.0918 16.7822C1.71547 16.5905 1.40974 16.2842 1.21799 15.9079C1 15.4801 1 14.9203 1 13.8002Z"
      stroke="#021C24"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CartIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <defs>
      <mask id="kaisr-cart-wheel" fill="white">
        <ellipse cx="1.58565" cy="1.62163" rx="1.58565" ry="1.62163" />
      </mask>
    </defs>
    <g transform="translate(3.1201 4)">
      <path
        d="M15.5676 11.4594L3.45904 11.4594L3.45904 9.5855L15.5676 9.5855L15.5676 11.4594Z"
        fill="#021C24"
      />
      <path
        d="M17.0816 5.11768L4.97302 5.11768L5.69377 3.2438L17.0816 3.2438L17.0816 5.11768Z"
        fill="#021C24"
      />
      <path
        d="M2.95508 1.87388L0 1.87388L1.63826e-07 5.98313e-08L2.95508 8.6803e-07L2.95508 1.87388Z"
        fill="#021C24"
      />
      <path
        d="M13.7927 10.972L15.6028 3.24332L17.081 3.24332L17.081 5.1172L15.6028 11.4569L13.7927 10.972Z"
        fill="#021C24"
      />
      <path
        d="M5.25713 11.0079L3.88769 4.50446L2.07759 4.98946L3.44703 11.4928L5.25713 11.0079Z"
        fill="#021C24"
      />
      <path
        d="M5.25664 11.0085L2.92614 0.0200513L1.11604 0.505046L3.44654 11.4935L5.25664 11.0085Z"
        fill="#021C24"
      />
    </g>
    <g transform="translate(8.2402 16.7568)">
      <path
        d="M3.17131 1.62163H1.54436C1.54436 1.62587 1.54396 1.62826 1.54377 1.62923C1.54355 1.63029 1.54335 1.63082 1.54326 1.63104C1.54296 1.63175 1.54277 1.63171 1.54362 1.63083C1.54449 1.62994 1.54837 1.62629 1.55695 1.62258C1.56132 1.62069 1.56642 1.61901 1.57196 1.61785C1.57761 1.61667 1.5824 1.6163 1.58565 1.6163V3.24325V4.8702C3.39414 4.8702 4.79826 3.38117 4.79826 1.62163H3.17131ZM1.58565 3.24325V1.6163C1.58891 1.6163 1.59369 1.61667 1.59935 1.61785C1.60489 1.61901 1.60999 1.62069 1.61436 1.62258C1.62294 1.62629 1.62681 1.62994 1.62768 1.63083C1.62854 1.63171 1.62834 1.63175 1.62805 1.63104C1.62796 1.63082 1.62775 1.63029 1.62754 1.62923C1.62735 1.62826 1.62695 1.62587 1.62695 1.62163H0H-1.62695C-1.62695 3.38117 -0.22283 4.8702 1.58565 4.8702V3.24325ZM0 1.62163H1.62695C1.62695 1.61738 1.62735 1.61499 1.62754 1.61402C1.62775 1.61297 1.62796 1.61243 1.62805 1.61221C1.62834 1.6115 1.62854 1.61154 1.62768 1.61242C1.62681 1.61331 1.62294 1.61696 1.61436 1.62067C1.60999 1.62256 1.60489 1.62424 1.59935 1.6254C1.59369 1.62658 1.58891 1.62695 1.58565 1.62695V0V-1.62695C-0.22283 -1.62695 -1.62695 -0.137916 -1.62695 1.62163H0ZM1.58565 0V1.62695C1.5824 1.62695 1.57761 1.62658 1.57196 1.6254C1.56642 1.62424 1.56132 1.62256 1.55695 1.62067C1.54837 1.61696 1.54449 1.61331 1.54362 1.61242C1.54277 1.61154 1.54296 1.6115 1.54326 1.61221C1.54335 1.61243 1.54355 1.61297 1.54377 1.61402C1.54396 1.61499 1.54436 1.61738 1.54436 1.62163H3.17131H4.79826C4.79826 -0.137916 3.39414 -1.62695 1.58565 -1.62695V0Z"
        fill="#021C24"
        mask="url(#kaisr-cart-wheel)"
      />
    </g>
    <g transform="translate(13.8574 16.7568)">
      <path
        d="M3.17131 1.62163H1.54436C1.54436 1.62587 1.54396 1.62826 1.54377 1.62923C1.54355 1.63029 1.54335 1.63082 1.54326 1.63104C1.54296 1.63175 1.54277 1.63171 1.54362 1.63083C1.54449 1.62994 1.54837 1.62629 1.55695 1.62258C1.56132 1.62069 1.56642 1.61901 1.57196 1.61785C1.57761 1.61667 1.5824 1.6163 1.58565 1.6163V3.24325V4.8702C3.39414 4.8702 4.79826 3.38117 4.79826 1.62163H3.17131ZM1.58565 3.24325V1.6163C1.58891 1.6163 1.59369 1.61667 1.59935 1.61785C1.60489 1.61901 1.60999 1.62069 1.61436 1.62258C1.62294 1.62629 1.62681 1.62994 1.62768 1.63083C1.62854 1.63171 1.62834 1.63175 1.62805 1.63104C1.62796 1.63082 1.62775 1.63029 1.62754 1.62923C1.62735 1.62826 1.62695 1.62587 1.62695 1.62163H0H-1.62695C-1.62695 3.38117 -0.22283 4.8702 1.58565 4.8702V3.24325ZM0 1.62163H1.62695C1.62695 1.61738 1.62735 1.61499 1.62754 1.61402C1.62775 1.61297 1.62796 1.61243 1.62805 1.61221C1.62834 1.6115 1.62854 1.61154 1.62768 1.61242C1.62681 1.61331 1.62294 1.61696 1.61436 1.62067C1.60999 1.62256 1.60489 1.62424 1.59935 1.6254C1.59369 1.62658 1.58891 1.62695 1.58565 1.62695V0V-1.62695C-0.22283 -1.62695 -1.62695 -0.137916 -1.62695 1.62163H0ZM1.58565 0V1.62695C1.5824 1.62695 1.57761 1.62658 1.57196 1.6254C1.56642 1.62424 1.56132 1.62256 1.55695 1.62067C1.54837 1.61696 1.54449 1.61331 1.54362 1.61242C1.54277 1.61154 1.54296 1.6115 1.54326 1.61221C1.54335 1.61243 1.54355 1.61297 1.54377 1.61402C1.54396 1.61499 1.54436 1.61738 1.54436 1.62163H3.17131H4.79826C4.79826 -0.137916 3.39414 -1.62695 1.58565 -1.62695V0Z"
        fill="#021C24"
        mask="url(#kaisr-cart-wheel)"
      />
    </g>
  </svg>
);

export const RevenueIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g transform="translate(2.9797 2.9833)">
      <path
        d="M16.8786 17.4566L0.864863 17.4566L0.864863 15.5811L16.8786 15.5811L16.8786 17.4566Z"
        fill="#021C24"
      />
      <path
        d="M0.865524 17.4566L0.865523 8.94476L2.74101 7.68242L2.74101 17.4566L0.865524 17.4566Z"
        fill="#021C24"
      />
      <path
        d="M10.3714 11.1025L9.35775 9.40482L12.0966 4.6456L13.1103 6.34333L10.3714 11.1025Z"
        fill="#021C24"
      />
      <path
        d="M6.67484 14.091L5.66115 12.3932L8.39997 7.63403L9.41366 9.33176L6.67484 14.091Z"
        fill="#021C24"
      />
      <path
        d="M8.96771 1.73104H14.6663L13.6204 3.60653H7.92176L8.96771 1.73104Z"
        fill="#021C24"
      />
      <path
        d="M17.5175 6.66631L14.6682 1.73118L13.5669 3.57473L16.4162 8.50986L17.5175 6.66631Z"
        fill="#021C24"
      />
    </g>
  </svg>
);

export const CreditsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M19 7V4C19 3.73478 18.8946 3.48043 18.7071 3.29289C18.5196 3.10536 18.2652 3 18 3H5C4.46957 3 3.96086 3.21071 3.58579 3.58579C3.21071 3.96086 3 4.46957 3 5C3 5.53043 3.21071 6.03914 3.58579 6.41421C3.96086 6.78929 4.46957 7 5 7H20C20.2652 7 20.5196 7.10536 20.7071 7.29289C20.8946 7.48043 21 7.73478 21 8V12M21 12H18C17.4696 12 16.9609 12.2107 16.5858 12.5858C16.2107 12.9609 16 13.4696 16 14C16 14.5304 16.2107 15.0391 16.5858 15.4142C16.9609 15.7893 17.4696 16 18 16H21C21.2652 16 21.5196 15.8946 21.7071 15.7071C21.8946 15.5196 22 15.2652 22 15V13C22 12.7348 21.8946 12.4804 21.7071 12.2929C21.5196 12.1054 21.2652 12 21 12Z"
      stroke="#02171D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 5V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H20C20.2652 21 20.5196 20.8946 20.7071 20.7071C20.8946 20.5196 21 20.2652 21 20V16"
      stroke="#02171D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RoundStatusIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22.0412"
    height="22.0424"
    viewBox="0 0 22.0412 22.0424"
    fill="none"
  >
    <path
      d="M12.2456 19.9885C8.66676 22.1139 4.09049 20.8526 2.02424 17.1714C-0.0420203 13.4902 1.18419 8.783 4.76305 6.65765C8.34191 4.53229 12.9182 5.79357 14.9844 9.4748C17.0507 13.156 15.8245 17.8632 12.2456 19.9885Z"
      stroke="#021C24"
      strokeWidth="2.04154"
    />
    <path
      d="M8.77646 2.78024C11.9644 0.0754992 16.6805 0.541165 19.31 3.82033C21.9395 7.0995 21.4868 11.9504 18.2988 14.6552"
      stroke="#021C24"
      strokeWidth="2.04154"
    />
    <rect
      width="4.7608"
      height="4.7608"
      transform="matrix(0.697068 0.717005 -0.697068 0.717005 8.45902 9.99696)"
      fill="#021C24"
    />
  </svg>
);

export const EntitlementIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g transform="translate(0.9456 0.9456)">
      <path
        d="M18.5161 14.1674L16.5314 16.152L15.7681 15.3887C15.5152 15.1358 15.1051 15.1358 14.8521 15.3887C14.5992 15.6417 14.5992 16.0517 14.8521 16.3047L16.0734 17.526C16.1999 17.6524 16.3656 17.7157 16.5314 17.7157C16.6971 17.7157 16.8629 17.6524 16.9893 17.526L19.4319 15.0834C19.6849 14.8305 19.6849 14.4204 19.4319 14.1674C19.1792 13.9145 18.769 13.9145 18.5161 14.1674Z"
        fill="#02171D"
      />
      <path
        d="M9.44112 13.9644C9.34108 13.929 9.23917 13.8923 9.13718 13.8543V12.0278C9.32458 12.0924 9.42156 12.1864 9.43439 12.1995C9.63063 12.4212 9.96942 12.4435 10.1931 12.2486C10.4178 12.0527 10.4413 11.7118 10.2454 11.4871C10.061 11.2755 9.67865 11.01 9.13718 10.9195V10.6219C9.13718 10.3238 8.89555 10.0822 8.59745 10.0822C8.29934 10.0822 8.05771 10.3238 8.05771 10.6219V10.9793C8.01988 10.9891 7.98176 10.9997 7.9432 11.0114C7.29068 11.2079 6.80336 11.7651 6.67136 12.4654C6.55033 13.1077 6.75858 13.7289 7.21472 14.0866C7.43308 14.2579 7.69962 14.4149 8.05771 14.5784V16.9495C7.79652 16.9148 7.60118 16.8294 7.29512 16.6292C7.04563 16.466 6.71117 16.5359 6.548 16.7854C6.38482 17.0349 6.45473 17.3694 6.70422 17.5326C7.23346 17.8788 7.60554 17.9981 8.05771 18.0354V18.3941C8.05771 18.6923 8.29934 18.9339 8.59745 18.9339C8.89555 18.9339 9.13718 18.6923 9.13718 18.3941V17.985C9.49186 17.8982 9.8144 17.7264 10.0876 17.4754C10.4528 17.1398 10.6993 16.6852 10.7817 16.1952C10.9511 15.1877 10.4249 14.312 9.44112 13.9644ZM7.88093 13.2373C7.74518 13.1308 7.68676 12.9063 7.73218 12.6654C7.76647 12.4835 7.86915 12.2724 8.05771 12.1406V13.3597C7.99376 13.3197 7.93404 13.2789 7.88093 13.2373ZM9.71717 16.0162C9.66462 16.3288 9.46811 16.6585 9.13718 16.8371V15.0033C9.77006 15.257 9.75473 15.7929 9.71717 16.0162Z"
        fill="#02171D"
      />
      <path
        d="M21.46 11.3129C20.6416 11.3129 19.9058 10.8581 19.5397 10.1261L19.4486 9.94383C19.3389 9.72435 19.1146 9.58575 18.8692 9.58575H15.4149C15.1696 9.58575 14.9453 9.72435 14.8356 9.94379L14.7445 10.1261C14.7094 10.1963 14.6708 10.2639 14.6292 10.3288C13.745 9.13638 12.7634 8.0753 11.8743 7.16275V5.04638C12.7338 3.83296 13.1696 2.49955 13.1696 1.07948V0.647686C13.1696 0.28999 12.8796 0 12.5219 0H12.0901C10.8906 0 9.32602 0.776877 8.63581 1.15487C7.94559 0.776877 6.381 0 5.18148 0H4.74969C4.392 0 4.10201 0.28999 4.10201 0.647686V1.07948C4.10201 2.4995 4.53786 3.83296 5.39738 5.04642V7.16301C2.69722 9.93873 0 13.282 0 17.1421L4.3179e-05 17.1885C0.00608824 19.901 2.24928 22.1077 5.00061 22.1077H12.271C13.2953 22.1077 14.2926 21.7943 15.1297 21.2174C15.6853 21.5922 16.2985 21.8831 16.9559 22.0803C17.0166 22.0986 17.0793 22.1077 17.1421 22.1077C17.2048 22.1077 17.2675 22.0986 17.3282 22.0803C18.7201 21.6628 19.9143 20.8258 20.7817 19.66C21.6492 18.4941 22.1077 17.1097 22.1077 15.6566V11.9606C22.1077 11.6029 21.8177 11.3129 21.46 11.3129ZM6.69275 5.48374H10.5789V6.77911H6.69275V5.48374ZM8.30354 2.45585C8.50795 2.578 8.76323 2.578 8.96781 2.45598C9.46972 2.15666 10.8956 1.41463 11.8697 1.30815C11.8287 2.33892 11.5078 3.28597 10.8937 4.18837H6.37793C5.7638 3.28592 5.44298 2.33888 5.40191 1.30815C6.37603 1.41463 7.80189 2.15666 8.30354 2.45585ZM5.00061 20.8123C2.962 20.8123 1.29986 19.1854 1.29541 17.1862L1.29537 17.1421C1.29537 13.7456 3.80256 10.661 6.31774 8.07448H10.954C11.8237 8.96742 12.7824 10.0044 13.6309 11.1573C13.3798 11.2586 13.1069 11.3129 12.8242 11.3129C12.4665 11.3129 12.1765 11.6029 12.1765 11.9606V15.6566C12.1765 17.1097 12.635 18.4941 13.5024 19.66C13.6825 19.902 13.8769 20.1296 14.084 20.3425C13.5326 20.648 12.909 20.8123 12.2711 20.8123H5.00061ZM20.8123 15.6566C20.8123 17.9993 19.3455 20.0343 17.1421 20.7802C14.9387 20.0343 13.4719 17.9993 13.4719 15.6566V12.5479C14.4521 12.3629 15.3042 11.7621 15.8089 10.8811H18.4752C18.9799 11.762 19.8321 12.3629 20.8123 12.5479V15.6566Z"
        fill="#02171D"
      />
    </g>
  </svg>
);

export const CalendarIcon = ({ active }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M11.1667 2.37333V1.33333C11.1667 1.05999 10.94 0.833328 10.6667 0.833328C10.3933 0.833328 10.1667 1.05999 10.1667 1.33333V2.33333H5.83332V1.33333C5.83332 1.05999 5.60666 0.833328 5.33332 0.833328C5.05999 0.833328 4.83332 1.05999 4.83332 1.33333V2.37333C3.03332 2.53999 2.15999 3.61333 2.02666 5.20666C2.01332 5.39999 2.17332 5.56 2.35999 5.56H13.64C13.8333 5.56 13.9933 5.39333 13.9733 5.20666C13.84 3.61333 12.9667 2.53999 11.1667 2.37333Z"
      fill={active ? "#329879" : "#869397"}
    />
    <path
      d="M13.3333 6.56H2.66667C2.3 6.56 2 6.86 2 7.22666V11.3333C2 13.3333 3 14.6667 5.33333 14.6667H10.6667C13 14.6667 14 13.3333 14 11.3333V7.22666C14 6.86 13.7 6.56 13.3333 6.56ZM6.14 12.14C6.10667 12.1667 6.07333 12.2 6.04 12.22C6 12.2467 5.96 12.2667 5.92 12.28C5.88 12.3 5.84 12.3133 5.8 12.32C5.75333 12.3267 5.71333 12.3333 5.66667 12.3333C5.58 12.3333 5.49333 12.3133 5.41333 12.28C5.32667 12.2467 5.26 12.2 5.19333 12.14C5.07333 12.0133 5 11.84 5 11.6667C5 11.4933 5.07333 11.32 5.19333 11.1933C5.26 11.1333 5.32667 11.0867 5.41333 11.0533C5.53333 11 5.66667 10.9867 5.8 11.0133C5.84 11.02 5.88 11.0333 5.92 11.0533C5.96 11.0667 6 11.0867 6.04 11.1133C6.07333 11.14 6.10667 11.1667 6.14 11.1933C6.26 11.32 6.33333 11.4933 6.33333 11.6667C6.33333 11.84 6.26 12.0133 6.14 12.14ZM6.14 9.80666C6.01333 9.92666 5.84 10 5.66667 10C5.49333 10 5.32 9.92666 5.19333 9.80666C5.07333 9.68 5 9.50666 5 9.33333C5 9.16 5.07333 8.98666 5.19333 8.86C5.38 8.67333 5.67333 8.61333 5.92 8.72C6.00667 8.75333 6.08 8.8 6.14 8.86C6.26 8.98666 6.33333 9.16 6.33333 9.33333C6.33333 9.50666 6.26 9.68 6.14 9.80666ZM8.47333 12.14C8.34667 12.26 8.17333 12.3333 8 12.3333C7.82667 12.3333 7.65333 12.26 7.52667 12.14C7.40667 12.0133 7.33333 11.84 7.33333 11.6667C7.33333 11.4933 7.40667 11.32 7.52667 11.1933C7.77333 10.9467 8.22667 10.9467 8.47333 11.1933C8.59333 11.32 8.66667 11.4933 8.66667 11.6667C8.66667 11.84 8.59333 12.0133 8.47333 12.14ZM8.47333 9.80666C8.44 9.83333 8.40667 9.86 8.37333 9.88666C8.33333 9.91333 8.29333 9.93333 8.25333 9.94666C8.21333 9.96666 8.17333 9.98 8.13333 9.98666C8.08667 9.99333 8.04667 10 8 10C7.82667 10 7.65333 9.92666 7.52667 9.80666C7.40667 9.68 7.33333 9.50666 7.33333 9.33333C7.33333 9.16 7.40667 8.98666 7.52667 8.86C7.58667 8.8 7.66 8.75333 7.74667 8.72C7.99333 8.61333 8.28667 8.67333 8.47333 8.86C8.59333 8.98666 8.66667 9.16 8.66667 9.33333C8.66667 9.50666 8.59333 9.68 8.47333 9.80666ZM10.8067 12.14C10.68 12.26 10.5067 12.3333 10.3333 12.3333C10.16 12.3333 9.98667 12.26 9.86 12.14C9.74 12.0133 9.66667 11.84 9.66667 11.6667C9.66667 11.4933 9.74 11.32 9.86 11.1933C10.1067 10.9467 10.56 10.9467 10.8067 11.1933C10.9267 11.32 11 11.4933 11 11.6667C11 11.84 10.9267 12.0133 10.8067 12.14ZM10.8067 9.80666C10.7733 9.83333 10.74 9.86 10.7067 9.88666C10.6667 9.91333 10.6267 9.93333 10.5867 9.94666C10.5467 9.96666 10.5067 9.98 10.4667 9.98666C10.42 9.99333 10.3733 10 10.3333 10C10.16 10 9.98667 9.92666 9.86 9.80666C9.74 9.68 9.66667 9.50666 9.66667 9.33333C9.66667 9.16 9.74 8.98666 9.86 8.86C9.92667 8.8 9.99333 8.75333 10.08 8.72C10.2 8.66666 10.3333 8.65333 10.4667 8.68C10.5067 8.68666 10.5467 8.7 10.5867 8.72C10.6267 8.73333 10.6667 8.75333 10.7067 8.78C10.74 8.80666 10.7733 8.83333 10.8067 8.86C10.9267 8.98666 11 9.16 11 9.33333C11 9.50666 10.9267 9.68 10.8067 9.80666Z"
      fill={active ? "#329879" : "#869397"}
    />
  </svg>
);

// `direction`: 1 = ascending (up arrow highlighted), -1 = descending
// (down arrow highlighted). Omit it to render both arrows dimmed.
export const SortIcon = ({ direction }) => {
  const DIM = "#77868B";
  const ACTIVE = "#02171D";
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="12" viewBox="0 0 9 12" fill="none">
      <path d="M7.90908 6.85718H4.09497H0.660442C0.072714 6.85718 -0.22115 7.63778 0.195157 8.09537L3.36644 11.5811C3.87458 12.1397 4.70107 12.1397 5.20921 11.5811L6.41528 10.2555L8.38049 8.09537C8.79068 7.63778 8.49681 6.85718 7.90908 6.85718Z" fill={direction === -1 ? ACTIVE : DIM} />
      <path d="M7.90908 5.14282H4.09497H0.660442C0.072714 5.14282 -0.22115 4.36222 0.195157 3.90463L3.36644 0.418863C3.87458 -0.139668 4.70107 -0.139668 5.20921 0.418863L6.41528 1.74453L8.38049 3.90463C8.79068 4.36222 8.49681 5.14282 7.90908 5.14282Z" fill={direction === 1 ? ACTIVE : DIM} />
    </svg>
  );
};

export const ExternalLinkIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      d="M5.83328 2.91665H4.78328C4.12989 2.91665 3.80295 2.91665 3.55339 3.04381C3.33386 3.15566 3.15552 3.33401 3.04366 3.55353C2.9165 3.80309 2.9165 4.13003 2.9165 4.78343V9.21676C2.9165 9.87015 2.9165 10.1967 3.04366 10.4462C3.15552 10.6658 3.33386 10.8444 3.55339 10.9563C3.8027 11.0833 4.12925 11.0833 4.78137 11.0833H9.21831C9.87042 11.0833 10.1965 11.0833 10.4458 10.9563C10.6653 10.8444 10.8443 10.6656 10.9561 10.4461C11.0832 10.1968 11.0832 9.87057 11.0832 9.21845V8.16665M8.74984 2.33331H11.6665V5.24998M11.6665 2.33331L7.58317 6.41665"
      stroke="#77868B"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CopyIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      d="M9.33333 7.525V9.975C9.33333 12.0167 8.51667 12.8333 6.475 12.8333H4.025C1.98333 12.8333 1.16667 12.0167 1.16667 9.975V7.525C1.16667 5.48333 1.98333 4.66667 4.025 4.66667H6.475C8.51667 4.66667 9.33333 5.48333 9.33333 7.525Z"
      stroke="#77868B"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.8333 4.025V6.475C12.8333 8.51667 12.0167 9.33333 9.975 9.33333H9.33333V7.525C9.33333 5.48333 8.51667 4.66667 6.475 4.66667H4.66667V4.025C4.66667 1.98333 5.48333 1.16667 7.525 1.16667H9.975C12.0167 1.16667 12.8333 1.98333 12.8333 4.025Z"
      stroke="#77868B"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowLeft = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
  >
    <path
      d="M7.88904 2.43555L5.38763 2.43555L1.99459 8.49682L4.496 8.49682L7.88904 2.43555Z"
      fill="#869397"
    />
    <path
      d="M7.88904 14.5703L5.38763 14.5703L1.99459 8.50904L3.57108 7.46117L4.496 8.50904L7.88904 14.5703Z"
      fill="#869397"
    />
    <path
      d="M8.01655 7.35742H14.9616L13.6869 9.64313H6.74182L8.01655 7.35742Z"
      fill="#869397"
    />
  </svg>
);

export const ArrowRight = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
  >
    <path
      d="M9.11108 2.43555L11.6125 2.43555L15.0055 8.49682L12.5041 8.49682L9.11108 2.43555Z"
      fill="#329879"
    />
    <path
      d="M9.11108 14.5703L11.6125 14.5703L15.0055 8.50904L13.429 7.46117L12.5041 8.50904L9.11108 14.5703Z"
      fill="#329879"
    />
    <path
      d="M3.31318 7.35742H10.2582L8.98351 9.64313H2.03845L3.31318 7.35742Z"
      fill="#329879"
    />
  </svg>
);
